export default __webpack_public_path__ + "static/media/tick.b3652228.png";